var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var StyledAccordion = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  background-color: ", ";\n  border-radius: 0.25rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  background-color: ", ";\n  border-radius: 0.25rem;\n"])), function (props) { var _a; return (_a = props.$width) !== null && _a !== void 0 ? _a : "340px"; }, function (props) { var _a; return (_a = props.$colorPalette) === null || _a === void 0 ? void 0 : _a.primary.background; });
var Accordion = function (_a) {
    var title = _a.title, children = _a.children, width = _a.width;
    var colorPalette = useTheme().theme.colorPalette;
    var Title = title &&
        (typeof title === "string" ? _jsx(Text, __assign({ variant: "div" }, { children: children })) : title);
    return (_jsxs(StyledAccordion, __assign({ "$width": width, "$colorPalette": colorPalette }, { children: [Title, React.Children.map(children, function (child) {
                return React.cloneElement(child, {
                    variant: "transparent",
                });
            })] })));
};
export default Accordion;
var templateObject_1;
